import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'coach-header',
  templateUrl: './coach-header.component.html',
  styleUrl: './coach-header.component.scss',
})
export class CoachHeaderComponent {
  @Input() titleKey = '';
  @Output() menuToggled = new EventEmitter();

  onToggleMenu() {
    this.menuToggled.emit();
  }
}
